module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": '罚单设置'
    }
  }, [_c('div', {
    staticClass: "tab-title"
  }, [_c('div', {
    staticClass: "tab-btn",
    class: {
      active: _vm.activeIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.changeTab(0)
      }
    }
  }, [_vm._v("系统罚单")]), _vm._v(" "), _c('div', {
    staticClass: "tab-btn",
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_vm._v("人工罚单")])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 0),
      expression: "activeIndex == 0"
    }],
    staticClass: "tab-main"
  }, [_c('div', {
    staticClass: "back-list"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_c('div', [_vm._v("编号")]), _vm._v(" "), _c('div', [_vm._v("罚单类型")]), _vm._v(" "), _c('div', [_vm._v("罚单金额")]), _vm._v(" "), _c('div', [_vm._v("适用对象")]), _vm._v(" "), _c('div', [_vm._v("罚单说明")]), _vm._v(" "), _c('div', [_vm._v("开关")]), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('z-scrollDiv', _vm._l((_vm.systemTicket), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item"
    }, [_c('div', [_vm._v(_vm._s(("C0" + (index+1))))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.ticket_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("ticket")(item.ticket_amount, item.ticket_name)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("ticketTar")(item.ticket_target)))]), _vm._v(" "), _c('div', {
      staticClass: "overhide"
    }, [_vm._v(_vm._s(item.ticket_description))]), _vm._v(" "), _c('div', [_c('el-switch', {
      attrs: {
        "on-color": "#34b96c",
        "on-text": "",
        "off-text": ""
      },
      on: {
        "change": function($event) {
          _vm.turn(item, index)
        }
      },
      model: {
        value: (item.ticket_switch),
        callback: function($$v) {
          _vm.$set(item, "ticket_switch", $$v)
        },
        expression: "item.ticket_switch"
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "blue",
      on: {
        "click": function($event) {
          _vm.link(item.id)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("btn")(item.ticket_name)))])])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("系统罚单编号以 \"C\" 开头")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 1),
      expression: "activeIndex == 1"
    }],
    staticClass: "tab-main"
  }, [_c('div', {
    staticClass: "btns-top"
  }, [_c('div', {
    staticClass: "back-btn blue",
    on: {
      "click": function($event) {
        _vm.link(0)
      }
    }
  }, [_vm._v("创建")])]), _vm._v(" "), _c('div', {
    staticClass: "back-list page"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_c('div', [_vm._v("编号")]), _vm._v(" "), _c('div', [_vm._v("罚单类型")]), _vm._v(" "), _c('div', [_vm._v("罚单金额")]), _vm._v(" "), _c('div', [_vm._v("适用对象")]), _vm._v(" "), _c('div', [_vm._v("罚单说明")]), _vm._v(" "), _c('div', [_vm._v("开关")]), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "main-special"
  }, [_vm._l((_vm.personTicket), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item"
    }, [_c('div', [_vm._v(_vm._s(("P0" + (index+1))))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.ticket_name
      }
    }, [_vm._v(_vm._s(item.ticket_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("ticket")(item.ticket_amount, item.ticket_name)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("ticketTar")(item.ticket_target)))]), _vm._v(" "), _c('div', {
      staticClass: "overhide"
    }, [_vm._v(_vm._s(item.ticket_description))]), _vm._v(" "), _c('div', [_c('el-switch', {
      attrs: {
        "on-color": "#34b96c",
        "on-text": "",
        "off-text": ""
      },
      on: {
        "change": function($event) {
          _vm.turn(item, index)
        }
      },
      model: {
        value: (item.ticket_switch),
        callback: function($$v) {
          _vm.$set(item, "ticket_switch", $$v)
        },
        expression: "item.ticket_switch"
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "blue",
      on: {
        "click": function($event) {
          _vm.link(item.id)
        }
      }
    }, [_vm._v("编辑")])])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.personTicket
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.personTicket.length != 0),
      expression: "personTicket.length != 0"
    }],
    staticClass: "tip"
  }, [_vm._v("人工罚单编号以 \"P\" 开头")])], 2)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-74e8e72a!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/setting/page-ticket.vue
// module id = 763
// module chunks = 1